import ApiService from "./ApiService";

const ROOT_URL = "/services/onboarding/api/document/private";

const DocumentApi = new ApiService(ROOT_URL, "", {
  create: function(ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, "/create", data, onSuccess, onError);
  },
  postMultiple: function(ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, "/create/multiple", data, onSuccess, onError);
  },
  getDocumentById: function(ctx, documentId, onSuccess, onError) {
    this.apiGET(ctx, "/id?id=" + documentId, onSuccess, onError);
  },
  getRecent: function(
    ctx,
    sourceType,
    sourceValue,
    documentType,
    onSuccess,
    onError
  ) {
    this.apiGET(
      ctx,
      "/get/recent?sourceType=" +
        sourceType +
        "&sourceValue=" +
        sourceValue +
        (documentType ? "&documentType=" + documentType : ""),
      onSuccess,
      onError
    );
  }
});

export default DocumentApi;



// WEBPACK FOOTER //
// ./src/service/DocumentService.js